<template>
    <div id="busca-listagem">
        <section id="content">
            <!--start container-->
            <div class="container">
                <div class="row">
                    <div class="col s10 m6 l6">
                        <h5 class="breadcrumbs-title">Resultado de busca : {{ busca }}</h5>
                    </div>
                </div>

                <div class="row">
                    <div class="col s12 m12 l12">
                        <div class="card">
                            <div class="card-content">
                                <span class="card-title">Leads</span>
                                <div class="row" v-if="itensCliente.length === 0">
                                    <div class="col s12 m12 l12">
                                        <div class="card gradient-45deg-purple-deep-orange gradient-shadow">
                                            <div class="card-content white-text">
                                                <p>Nenhum lead encontrado.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="itensCliente.length > 0">
                                    <div v-for="item in itensCliente">
                                        <div class="divider"></div>
                                        <router-link :to="item.url">
                                            <span>{{ item.title }}</span>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col s12 m12 l12">
                        <div class="card">
                            <div class="card-content">
                                <span class="card-title">Pedidos</span>
                                <div class="row" v-if="itensPedido.length === 0">
                                    <div class="col s12 m12 l12">
                                        <div class="card gradient-45deg-purple-deep-orange gradient-shadow">
                                            <div class="card-content white-text">
                                                <p>Nenhum pedido encontrado.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="itensPedido.length > 0">
                                    <div v-for="item in itensPedido">
                                        <div class="divider"></div>
                                        <router-link :to="item.url">
                                            <span>{{ item.title }}</span>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>

<script>
    import { get } from '@/helpers/api';

    export default {
        components: {},
        data: () => ({
            busca: '',
            itens: [],
            itensCliente: [],
            itensPedido: [],
        }),
        created() {
            this.showLoading();
            this.busca = this.$route.query.busca;
            this.itens = [];

            get('cliente/busca/'+this.busca).then((response) => {
                let data = response.data.result.data;
                data.forEach((obj) => {
                    let title = obj.pessoa_nome;
                    if (obj.pessoa_profissao) {
                        title += ' - '+obj.pessoa_profissao;
                    }
                    if (obj.pessoa_celular) {
                        title += ' - '+this.$options.filters.phone(obj.pessoa_celular);
                    }
                    if (obj.pessoa_telefone) {
                        title += ' - '+this.$options.filters.phone(obj.pessoa_telefone);
                    }
                    this.itensCliente.push({
                        title: title,
                        url: 'cliente/'+obj.cliente_id
                    });

                    let titlePedido = obj.pessoa_nome;
                    if (obj.pedido_estagio_nome) {
                        titlePedido += ' - Estágio: '+obj.pedido_estagio_nome;
                    }
                    this.itensPedido.push({
                        title: titlePedido,
                        url: 'lead-gerenciamento/'+obj.pedido_id
                    });
                });
                this.hideLoading();
            })
        },
        methods: {
            showLoading () {
                this.$parent.$emit('showLoading', true);
            },
            hideLoading () {
                this.$parent.$emit('showLoading', false);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/busca/Resultado.vue